module.exports = __webpack_public_path__ + "static/media/teygja_bakvodvar_nidurtog.28b97550.png";